// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-import-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

.confirm-import-modal {
  background: #ffffff;
  border-radius: 12px;
  width: 90%;
  max-width: 520px;
  max-height: 85vh;
  padding: 22px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.confirm-import-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.confirm-import-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1b1b1b;
}

.confirm-import-close {
  background: none;
  border: none;
  font-size: 1.15rem;
  color: #666;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.confirm-import-close:hover {
  background-color: #f0f0f0;
}

.confirm-import-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 40px 20px;
  color: #666;
  text-align: center;
}

.confirm-import-subtitle {
  margin: 4px 0 12px 0;
  font-size: 0.95rem;
  color: #444;
}

.confirm-import-list {
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  max-height: 320px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.confirm-import-selectall {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-size: 0.88rem;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e2e2e2;
  cursor: pointer;
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 1;
  margin: 0;
}

.confirm-import-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  font-size: 0.9rem;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  margin: 0;
}

.confirm-import-row:hover {
  background: #faf8ff;
}

.confirm-import-row:last-child {
  border-bottom: none;
}

.confirm-import-row-icon {
  color: #5616ea;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.confirm-import-row-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.confirm-import-empty {
  padding: 24px;
  text-align: center;
  font-size: 0.9rem;
  color: #666;
  background-color: #f9f9f9;
  border: 1px dashed #bbb;
  border-radius: 8px;
}

.confirm-import-warning {
  margin-top: 12px;
  padding: 10px 12px;
  background-color: #fff8e6;
  border: 1px solid #ffcc00;
  border-radius: 8px;
  font-size: 0.85rem;
  color: #856404;
  line-height: 1.4;
}

.confirm-import-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmImportModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".confirm-import-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1300;\r\n}\r\n\r\n.confirm-import-modal {\r\n  background: #ffffff;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 520px;\r\n  max-height: 85vh;\r\n  padding: 22px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.confirm-import-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.confirm-import-header h2 {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  color: #1b1b1b;\r\n}\r\n\r\n.confirm-import-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.15rem;\r\n  color: #666;\r\n  cursor: pointer;\r\n  padding: 6px;\r\n  border-radius: 6px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.confirm-import-close:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.confirm-import-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 14px;\r\n  padding: 40px 20px;\r\n  color: #666;\r\n  text-align: center;\r\n}\r\n\r\n.confirm-import-subtitle {\r\n  margin: 4px 0 12px 0;\r\n  font-size: 0.95rem;\r\n  color: #444;\r\n}\r\n\r\n.confirm-import-list {\r\n  border: 1px solid #e2e2e2;\r\n  border-radius: 8px;\r\n  max-height: 320px;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.confirm-import-selectall {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 10px;\r\n  font-size: 0.88rem;\r\n  font-weight: 600;\r\n  color: #333;\r\n  border-bottom: 1px solid #e2e2e2;\r\n  cursor: pointer;\r\n  position: sticky;\r\n  top: 0;\r\n  background: #ffffff;\r\n  z-index: 1;\r\n  margin: 0;\r\n}\r\n\r\n.confirm-import-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 2px 10px;\r\n  font-size: 0.9rem;\r\n  color: #333;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  cursor: pointer;\r\n  margin: 0;\r\n}\r\n\r\n.confirm-import-row:hover {\r\n  background: #faf8ff;\r\n}\r\n\r\n.confirm-import-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.confirm-import-row-icon {\r\n  color: #5616ea;\r\n  font-size: 0.9rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.confirm-import-row-name {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.confirm-import-empty {\r\n  padding: 24px;\r\n  text-align: center;\r\n  font-size: 0.9rem;\r\n  color: #666;\r\n  background-color: #f9f9f9;\r\n  border: 1px dashed #bbb;\r\n  border-radius: 8px;\r\n}\r\n\r\n.confirm-import-warning {\r\n  margin-top: 12px;\r\n  padding: 10px 12px;\r\n  background-color: #fff8e6;\r\n  border: 1px solid #ffcc00;\r\n  border-radius: 8px;\r\n  font-size: 0.85rem;\r\n  color: #856404;\r\n  line-height: 1.4;\r\n}\r\n\r\n.confirm-import-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin-top: 18px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
